<template lang="pug">
v-container.pa-4
  h2.my-2 Usuários
  v-btn(text @click='createUserDialog = true') Cadastrar usuário
  list(url='/users/search_user' title='Usuários' attribute='users' listBy='email')
  v-dialog(v-model='createUserDialog' width='400px')
    v-card
      v-card-title
        | Cadastrar Usuário
        v-spacer
        v-btn(icon @click='createUserDialog = false')
          v-icon mdi-close
      v-card-text
        v-form(ref='form' :novalidate='false')
          v-text-field(v-model='newUser.email' label='E-mail' :rules='inputRules')
          v-text-field(
            v-model='newUser.password'
            :type="show ? 'text' : 'password'"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append='show = !show'
            label='Senha'
            :rules='inputRules'
          )
          h4 Pessoa
          v-text-field(v-model='newUser.person.name' label='Nome' :rules='inputRules')
          v-text-field(v-model='newUser.person.code' label='Código')
          v-text-field(v-model='newUser.person.cpf' :rules='[validator.validateCPF(newUser.person.cpf)]' label='CPF' v-mask='cpfMask')
          v-text-field(v-model='newUser.person.email' label='E-mail')
          span Imagem
          input(type='file' accept='image/*' @change='onFilePicked')
          v-text-field(v-model='newUser.person.phone' label='Telefone' v-mask='phoneMask')
          v-text-field(v-model='newUser.person.company' label='Empresa')
          v-text-field(v-model='newUser.person.role' label='Profissão')
          v-text-field(v-model='newUser.person.address' label='Rua')
          v-text-field(v-model='newUser.person.address_number' label='Número da rua')
          v-text-field(v-model='newUser.person.address_addon' label='Complemento')
          v-text-field(v-model='newUser.person.neighbourhood' label='Bairro')
          v-text-field(v-model='newUser.person.city' label='Cidade')
          v-select(v-model='newUser.person.state' label='Estado' :items='states')
          v-text-field(v-model='newUser.person.zip_code' label='CEP' v-mask='cepMask')
      v-card-actions
        v-btn(@click='$refs.form.reset()' :disabled='creatingUser') Limpar
        v-spacer
        v-btn(@click='createNewUser()' :loading='creatingUser') Salvar
  v-snackbar(v-model='userCreatedSnackbar')
    div Usuário criado!
    v-btn(icon @click='userCreatedSnackbar = false')
      v-icon mdi-close
</template>

<script>
import utils from '../utils/requests'
import validator from '../utils/validators'
import states from '../utils/states'
import List from '../components/List'

export default {
  components: {
    List
  },
  data () {
    return {
      validator: validator,
      cpfMask: '###.###.###-##',
      cepMask: '#####-###',
      phoneMask: '(##) # ####-####',
      createUserDialog: false,
      states: states,
      newUser: {
        email: '',
        password: '',
        person: {
          name: '',
          code: '',
          cpf: '',
          email: '',
          image: '',
          phone: '',
          company: '',
          role: '',
          address: '',
          address_number: '',
          address_addon: '',
          neighbourhood: '',
          city: '',
          state: '',
          zip_code: ''
        }
      },
      creatingUser: false,
      userCreatedSnackbar: false,
      show: false,
      inputRules: [
        v => !!v || 'Este campo é obrigatório'
      ],
      imgUpdated: ''
    }
  },
  methods: {
    createNewUser () {
      if (this.$refs.form.validate()) {
        this.creatingUser = true
        const data = {
          email: this.newUser.email,
          password: this.newUser.password,
          person: {
            name: this.newUser.person.name,
            code: this.newUser.person.code,
            cpf: this.newUser.person.cpf,
            email: this.newUser.person.email,
            image: this.newUser.person.image, // tratar
            phone: this.newUser.person.phone,
            company: this.newUser.person.company,
            role: this.newUser.person.role,
            address: this.newUser.person.address,
            address_number: this.newUser.person.address_number,
            address_addon: this.newUser.person.address_addon,
            neighborhood: this.newUser.person.neighbourhood,
            city: this.newUser.person.city,
            state: this.newUser.person.state,
            zip_code: this.newUser.person.zip_code
          }
        }
        utils.postAPI('/users/create_user', data).then(res => {
          console.log(res)
          this.createUser = false
          this.createUserDialog = false
          this.userCreatedSnackbar = true
        })
      }
    },
    onFilePicked (event) {
      const files = event.target.files

      const fileReader = new FileReader()

      fileReader.addEventListener('onload', () => {
        this.newUser.person.image = fileReader.result // base64 format
      })

      fileReader.readAsDataURL(files[0])
      console.log('base64: ', this.newUser.person.image)
    }
  }
}
</script>
